export function applyTimeDigit(currentDigits, digit) {
    if (!/^\d$/.test(digit) || currentDigits.length >= 4) {
        return currentDigits;
    }
    if (currentDigits.length === 0 && Number(digit) > 2) {
        return `0${digit}`;
    }
    if (currentDigits.length === 1) {
        const hour = Number(`${currentDigits}${digit}`);
        if (hour > 23) {
            return currentDigits;
        }
        return `${currentDigits}${digit}`;
    }
    if (currentDigits.length === 2 && Number(digit) > 5) {
        return currentDigits;
    }
    if (currentDigits.length === 3) {
        const minute = Number(`${currentDigits[2]}${digit}`);
        if (minute > 59) {
            return currentDigits;
        }
    }
    return `${currentDigits}${digit}`;
}
export function applyTimeDigitSequence(currentDigits, addedDigits) {
    let result = currentDigits;
    for (const digit of addedDigits) {
        result = applyTimeDigit(result, digit);
    }
    return result.slice(0, 4);
}
export function formatTimeDigits(digits) {
    if (digits.length === 0) {
        return "";
    }
    if (digits.length <= 2) {
        return digits.length === 2 ? `${digits}:` : digits;
    }
    return `${digits.slice(0, 2)}:${digits.slice(2)}`;
}
export function timeToDigits(value) {
    return value.replace(/\D/g, "").slice(0, 4);
}
export function isTimeDigitsComplete(digits) {
    return digits.length === 4;
}
export function caretToDigitIndex(caret, digits) {
    const length = digits.length;
    const safeCaret = Math.max(0, caret);
    if (length <= 1) {
        return Math.min(safeCaret, length);
    }
    if (length === 2) {
        return Math.min(safeCaret, 2);
    }
    if (safeCaret <= 2) {
        return safeCaret;
    }
    return Math.min(safeCaret - 1, length);
}
export function digitIndexToCaret(digitIndex, digits) {
    const length = digits.length;
    const safeIndex = Math.max(0, Math.min(digitIndex, length));
    if (length <= 1) {
        return safeIndex;
    }
    if (length === 2) {
        return safeIndex >= 2 ? 3 : safeIndex;
    }
    if (safeIndex <= 2) {
        return safeIndex === 2 ? 3 : safeIndex;
    }
    return safeIndex + 1;
}
export function removeDigitBefore(digits, digitIndex) {
    if (digitIndex <= 0) {
        return digits;
    }
    const index = digitIndex - 1;
    return `${digits.slice(0, index)}${digits.slice(index + 1)}`;
}
export function removeDigitAfter(digits, digitIndex) {
    if (digitIndex >= digits.length) {
        return digits;
    }
    return `${digits.slice(0, digitIndex)}${digits.slice(digitIndex + 1)}`;
}
